import type { UserStatus } from './schibsted-account/types.js';

import { isLocalhost } from './utils/is-localhost.js';

export function initMblTracker({ isLoggedIn, isSubscriber }: UserStatus): void {
  const addMetaElement = (property: string, value: boolean) => {
    const mblSubscriberMeta = document.createElement('meta');
    mblSubscriberMeta.setAttribute('property', property);
    mblSubscriberMeta.setAttribute('content', `${value}`);
    document.head.appendChild(mblSubscriberMeta);
  };

  // add meta elements so we can test it
  addMetaElement('mbl:login', isLoggedIn);
  addMetaElement('k5a:login', isLoggedIn);
  addMetaElement('mbl:subscriber', isSubscriber);
  addMetaElement('k5a:subscriber', isSubscriber);

  // but do not load the tracking script for the localhost
  if (!isLocalhost()) {
    const mblScript = document.createElement('script');
    mblScript.defer = true;
    mblScript.src = 'https://log.medietall.no/analytics.js';
    document.head.appendChild(mblScript);
  }
}
